import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import TableDataLayerDispatch from "../components/TableDataLayerDispatch";

const TableDataPageDispatch = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>
        {/* TableDataLayer */}
        <TableDataLayerDispatch />

      </MasterLayout>

    </>
  );
};

export default TableDataPageDispatch; 
